/* ============================================================
   COTIZADOR — form 4 pasos + submit a Apps Script webhook.
   Loaded from layout/theme.liquid when template.suffix == 'cotizador'.

   Flow:
   1. Step 1-3: navegación, validación, prefill ?cat=, upload con límites.
   2. Submit (step 3 → 4):
      a) Si SPECWORKS_CONFIG.cotizadorWebhookUrl está vacío → fallback wa.me
         con resumen + folio random local (modo "no configurado").
      b) Si está configurado → POST JSON con archivos base64. Backend
         devuelve { ok: true, folio: "SPC-0042" }. Frontend renderea folio
         y muestra botón wa.me con folio prellenado.
      c) Si fetch falla / 500 → muestra panel .cot-error con wa.me directo.
   ============================================================ */
(function () {
  const form = document.getElementById('cotForm');
  if (!form) return;

  const config = window.SPECWORKS_CONFIG || {};
  const webhookUrl = (config.cotizadorWebhookUrl || '').trim();
  const waNumber = (config.whatsappNumber || '525500000000').replace(/\D/g, '');

  const MAX_FILES = parseInt(form.dataset.maxFiles, 10) || 5;
  const MAX_BYTES = (parseInt(form.dataset.maxMb, 10) || 5) * 1024 * 1024;

  /* ---------- State ---------- */
  const state = {
    step: 1,
    images: [],
    categoria: '',
    dim_l: '', dim_w: '', dim_h: '',
    material: 'No estoy seguro',
    acabado: 'Crudo (sin pintura)',
    plazo: '10 días',
    nombre: '',
    whatsapp: '',
    email: '',
    descripcion: '',
    consent: false,
    folio: ''
  };

  /* ---------- Reveal observer ---------- */
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-visible'); });
  }, { threshold: 0.15 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  /* ---------- Step navigation ---------- */
  const panes = document.querySelectorAll('.form-pane');
  const stepBtns = document.querySelectorAll('.cot-step');

  function goToStep(n) {
    if (n < 1 || n > 4) return;
    state.step = n;
    panes.forEach(p => {
      p.classList.toggle('is-active', parseInt(p.dataset.pane, 10) === n);
    });
    stepBtns.forEach(b => {
      const idx = parseInt(b.dataset.step, 10);
      b.classList.remove('is-active', 'is-done');
      if (idx < n) b.classList.add('is-done');
      else if (idx === n) b.classList.add('is-active');
    });
    const progressEl = document.querySelector('.cot-progress');
    if (progressEl) {
      window.scrollTo({ top: progressEl.offsetTop - 8, behavior: 'smooth' });
    }
    if (n === 3) updateSummary();
    if (n === 4) {
      const card = document.getElementById('confirmCard');
      if (card) setTimeout(() => card.focus(), 400);
    }
  }

  document.querySelectorAll('[data-next]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (!validateStep(state.step)) return;
      collectStep(state.step);
      goToStep(state.step + 1);
    });
  });
  document.querySelectorAll('[data-prev]').forEach(btn => {
    btn.addEventListener('click', () => goToStep(state.step - 1));
  });
  stepBtns.forEach(b => {
    b.addEventListener('click', () => {
      const idx = parseInt(b.dataset.step, 10);
      if (idx < state.step) goToStep(idx);
    });
  });

  /* ---------- Field error helpers ---------- */
  function setFieldError(name, msg) {
    const el = document.querySelector('[data-error-for="' + name + '"]');
    if (!el) return;
    if (msg) {
      el.textContent = msg;
      el.classList.add('is-visible');
    } else {
      el.textContent = '';
      el.classList.remove('is-visible');
    }
  }
  function clearAllErrors() {
    document.querySelectorAll('.field-error').forEach(el => {
      el.textContent = '';
      el.classList.remove('is-visible');
    });
    document.querySelectorAll('.form-chips.is-invalid').forEach(el => el.classList.remove('is-invalid'));
  }

  /* ---------- Validation ---------- */
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function digitsOnly(s) { return (s || '').replace(/\D/g, ''); }

  function validateStep(n) {
    if (n === 1) {
      let ok = true;
      if (!state.categoria) {
        document.querySelector('[data-chip-group="categoria"]').classList.add('is-invalid');
        setFieldError('categoria', 'Selecciona una categoría para continuar.');
        flashRequired('[data-chip-group="categoria"]');
        ok = false;
      } else {
        setFieldError('categoria', '');
      }

      // Vehículo (Marca / Modelo / Año).
      const marca = document.getElementById('marca');
      const marcaVal = marca.value.trim();
      if (!marcaVal || marcaVal.length < 2) {
        marca.classList.add('is-invalid');
        setFieldError('marca', 'Indícanos la marca del vehículo.');
        ok = false;
      } else {
        marca.classList.remove('is-invalid');
        setFieldError('marca', '');
      }

      const modelo = document.getElementById('modelo');
      const modeloVal = modelo.value.trim();
      if (!modeloVal) {
        modelo.classList.add('is-invalid');
        setFieldError('modelo', 'Indícanos el modelo del vehículo.');
        ok = false;
      } else {
        modelo.classList.remove('is-invalid');
        setFieldError('modelo', '');
      }

      const anio = document.getElementById('anio');
      const anioVal = anio.value.trim();
      const anioNum = parseInt(anioVal, 10);
      if (!anioVal || isNaN(anioNum) || anioNum < 1900 || anioNum > 2027) {
        anio.classList.add('is-invalid');
        setFieldError('anio', 'Año entre 1900 y 2027.');
        ok = false;
      } else {
        anio.classList.remove('is-invalid');
        setFieldError('anio', '');
      }

      const desc = document.getElementById('descripcion');
      const descVal = desc.value.trim();
      if (!descVal) {
        desc.classList.add('is-invalid');
        setFieldError('descripcion', 'Cuéntanos brevemente qué pieza necesitas — vehículo, ubicación, problema.');
        ok = false;
      } else if (descVal.length < 10) {
        desc.classList.add('is-invalid');
        setFieldError('descripcion', 'La descripción es muy corta — danos al menos un par de líneas para entenderte.');
        ok = false;
      } else {
        desc.classList.remove('is-invalid');
        setFieldError('descripcion', '');
      }
      return ok;
    }
    if (n === 2) {
      let ok = true;
      const dl = document.querySelector('[name="dim_l"]');
      const dw = document.querySelector('[name="dim_w"]');
      const dh = document.querySelector('[name="dim_h"]');
      let dimsOk = true;
      [dl, dw, dh].forEach(input => {
        const val = input.value.trim();
        const num = parseFloat(val);
        if (!val || isNaN(num) || num <= 0) {
          input.classList.add('is-invalid');
          dimsOk = false;
        } else {
          input.classList.remove('is-invalid');
        }
      });
      if (!dimsOk) {
        setFieldError('dimensiones', 'Captura las tres medidas (Largo, Ancho, Alto) — un aproximado en cm está bien.');
        flashRequired('.dim-row');
        ok = false;
      } else {
        setFieldError('dimensiones', '');
      }
      if (!state.plazo) {
        document.querySelector('[data-chip-group="plazo"]').classList.add('is-invalid');
        setFieldError('plazo', 'Elige un plazo deseado.');
        flashRequired('[data-chip-group="plazo"]');
        ok = false;
      } else {
        setFieldError('plazo', '');
      }
      return ok;
    }
    if (n === 3) {
      let ok = true;
      const nombre = document.getElementById('nombre');
      const wa = document.getElementById('whatsapp');
      const email = document.getElementById('email');

      const nombreVal = nombre.value.trim();
      if (!nombreVal) {
        nombre.classList.add('is-invalid');
        setFieldError('nombre', 'Necesitamos tu nombre para personalizar la cotización.');
        ok = false;
      } else if (nombreVal.length < 2) {
        nombre.classList.add('is-invalid');
        setFieldError('nombre', 'El nombre es muy corto.');
        ok = false;
      } else {
        nombre.classList.remove('is-invalid');
        setFieldError('nombre', '');
      }

      const waDigits = digitsOnly(wa.value);
      if (!waDigits) {
        wa.classList.add('is-invalid');
        setFieldError('whatsapp', 'Captura tu WhatsApp para mandarte la cotización.');
        ok = false;
      } else if (waDigits.length < 10) {
        wa.classList.add('is-invalid');
        setFieldError('whatsapp', 'El número parece incompleto — necesitamos al menos 10 dígitos.');
        ok = false;
      } else {
        wa.classList.remove('is-invalid');
        setFieldError('whatsapp', '');
      }

      const emailVal = email.value.trim();
      if (!emailVal) {
        email.classList.add('is-invalid');
        setFieldError('email', 'Captura tu email para mandarte la cotización formal.');
        ok = false;
      } else if (!EMAIL_RE.test(emailVal)) {
        email.classList.add('is-invalid');
        setFieldError('email', 'El email no parece válido (ej: nombre@correo.mx).');
        ok = false;
      } else {
        email.classList.remove('is-invalid');
        setFieldError('email', '');
      }

      if (!state.consent) {
        document.getElementById('consentLabel').style.borderColor = 'var(--red-hot)';
        setFieldError('consent', 'Necesitamos tu consentimiento para contactarte.');
        ok = false;
      } else {
        setFieldError('consent', '');
      }
      return ok;
    }
    return true;
  }

  function flashRequired(sel) {
    const el = document.querySelector(sel);
    if (!el || !el.animate) return;
    el.animate(
      [{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }],
      { duration: 320, easing: 'ease-out' }
    );
  }

  function collectStep(n) {
    if (n === 1) {
      state.marca = document.getElementById('marca').value.trim();
      state.modelo = document.getElementById('modelo').value.trim();
      state.anio = document.getElementById('anio').value.trim();
      state.descripcion = document.getElementById('descripcion').value.trim();
    }
    if (n === 2) {
      state.dim_l = document.querySelector('[name="dim_l"]').value;
      state.dim_w = document.querySelector('[name="dim_w"]').value;
      state.dim_h = document.querySelector('[name="dim_h"]').value;
    }
  }

  /* ---------- Chips ---------- */
  document.querySelectorAll('[data-chip-group]').forEach(group => {
    const key = group.dataset.chipGroup;
    const on = group.querySelector('.form-chip.is-on');
    if (on) state[key] = on.dataset.value;

    group.querySelectorAll('.form-chip').forEach(chip => {
      chip.addEventListener('click', () => {
        group.querySelectorAll('.form-chip').forEach(c => c.classList.remove('is-on'));
        chip.classList.add('is-on');
        state[key] = chip.dataset.value;
        group.classList.remove('is-invalid');
        setFieldError(key, '');
      });
    });
  });

  /* Prefill ?cat=interior — selecciona el chip correspondiente al cargar */
  (function prefillCategoria() {
    const params = new URLSearchParams(window.location.search);
    const cat = (params.get('cat') || '').toLowerCase();
    if (!cat) return;
    const chip = document.querySelector('[data-chip-group="categoria"] [data-cat="' + cat + '"]');
    if (!chip) return;
    document.querySelectorAll('[data-chip-group="categoria"] .form-chip').forEach(c => c.classList.remove('is-on'));
    chip.classList.add('is-on');
    state.categoria = chip.dataset.value;
  })();

  /* ---------- Radios ---------- */
  document.querySelectorAll('[data-radio-group]').forEach(group => {
    const name = group.dataset.radioGroup;
    const cards = group.querySelectorAll('.radio-card');
    function refresh() {
      cards.forEach(c => {
        const input = c.querySelector('input');
        c.classList.toggle('is-on', input.checked);
        if (input.checked) state[name] = input.value;
      });
    }
    cards.forEach(c => {
      c.addEventListener('click', e => {
        const input = c.querySelector('input');
        if (e.target !== input) input.checked = true;
        refresh();
      });
    });
    refresh();
  });

  /* ---------- Consent ---------- */
  const consentLabel = document.getElementById('consentLabel');
  const consentInput = document.getElementById('consent');

  function setConsent(checked) {
    consentInput.checked = checked;
    state.consent = checked;
    consentLabel.classList.toggle('is-on', checked);
    consentLabel.setAttribute('aria-checked', checked ? 'true' : 'false');
    consentLabel.style.borderColor = '';
    if (checked) setFieldError('consent', '');
  }

  consentLabel.addEventListener('click', e => {
    e.preventDefault();
    setConsent(!consentInput.checked);
  });
  consentLabel.setAttribute('tabindex', '0');
  consentLabel.setAttribute('role', 'checkbox');
  consentLabel.setAttribute('aria-checked', 'false');
  consentLabel.addEventListener('keydown', e => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      setConsent(!consentInput.checked);
    }
  });

  /* ---------- Inputs: clear invalid on input ---------- */
  ['dim_l', 'dim_w', 'dim_h'].forEach(name => {
    const el = document.querySelector('[name="' + name + '"]');
    if (!el) return;
    el.addEventListener('input', () => {
      el.classList.remove('is-invalid');
      setFieldError('dimensiones', '');
    });
  });
  ['nombre', 'whatsapp', 'email'].forEach(id => {
    const el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('input', () => {
      el.classList.remove('is-invalid');
      setFieldError(id, '');
      state[id] = el.value.trim();
    });
  });
  const descripcionEl = document.getElementById('descripcion');
  if (descripcionEl) {
    descripcionEl.addEventListener('input', () => {
      descripcionEl.classList.remove('is-invalid');
      setFieldError('descripcion', '');
    });
  }

  /* ---------- Upload ---------- */
  const zone = document.getElementById('uploadZone');
  const fileInput = document.getElementById('fileInput');
  const thumbsEl = document.getElementById('uploadThumbs');
  const errorEl = document.getElementById('uploadError');
  const counterEl = document.getElementById('uploadCounter');
  const MAX_MB = MAX_BYTES / 1024 / 1024;

  function showUploadError(msg, persist) {
    errorEl.textContent = msg;
    errorEl.classList.add('is-visible');
    if (!persist) {
      setTimeout(() => errorEl.classList.remove('is-visible'), 5500);
    }
  }
  function hideUploadError() {
    errorEl.classList.remove('is-visible');
  }

  function refreshUploadState() {
    if (counterEl) counterEl.textContent = state.images.length;
    zone.classList.toggle('is-full', state.images.length >= MAX_FILES);
  }

  function renderThumbs() {
    thumbsEl.innerHTML = '';
    state.images.forEach((img, i) => {
      const t = document.createElement('div');
      t.className = 'upload-thumb';
      t.innerHTML =
        '<img src="' + img.url + '" alt="">' +
        '<div class="thumb-meta">IMG ' + String(i + 1).padStart(2, '0') + '</div>' +
        '<button type="button" class="thumb-rm" aria-label="Quitar imagen ' + (i + 1) + '">' +
          '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8"/></svg>' +
        '</button>';
      t.querySelector('.thumb-rm').addEventListener('click', () => {
        URL.revokeObjectURL(state.images[i].url);
        state.images.splice(i, 1);
        renderThumbs();
        refreshUploadState();
        hideUploadError();
      });
      thumbsEl.appendChild(t);
    });
  }

  function addFiles(files) {
    const incoming = Array.from(files);
    if (incoming.length === 0) return;

    const remaining = MAX_FILES - state.images.length;

    /* Caso 1: ya hay 5 archivos y el usuario intenta agregar más */
    if (remaining <= 0) {
      showUploadError(
        'Llegaste al límite de ' + MAX_FILES + ' archivos. Quita uno de los actuales antes de agregar otro.'
      );
      return;
    }

    /* Caso 2: el usuario suelta más archivos de los que caben */
    const willTruncate = incoming.length > remaining;
    const accepted = incoming.slice(0, remaining);
    const overflow = incoming.length - remaining;

    let rejectedSize = 0;
    let rejectedType = 0;

    accepted.forEach(f => {
      if (!f.type.startsWith('image/')) {
        rejectedType++;
        return;
      }
      if (f.size > MAX_BYTES) {
        rejectedSize++;
        return;
      }
      state.images.push({
        name: f.name,
        url: URL.createObjectURL(f),
        size: f.size,
        type: f.type,
        file: f
      });
    });

    /* Mensajes ordenados por gravedad — mostramos el más relevante */
    if (willTruncate) {
      showUploadError(
        'Excediste el límite. Solo agregamos ' + (remaining - rejectedSize - rejectedType) +
        ' archivo' + (remaining === 1 ? '' : 's') +
        '; ' + overflow + ' se omitieron porque el máximo es ' + MAX_FILES + '.'
      );
    } else if (rejectedSize > 0 && rejectedType > 0) {
      showUploadError(rejectedSize + ' archivo(s) excedían ' + MAX_MB + ' MB y ' + rejectedType + ' no eran imagen — se omitieron.');
    } else if (rejectedSize > 0) {
      showUploadError(
        rejectedSize + ' archivo' + (rejectedSize === 1 ? '' : 's') +
        ' excedía' + (rejectedSize === 1 ? '' : 'n') + ' los ' + MAX_MB + ' MB y se omiti' + (rejectedSize === 1 ? 'ó' : 'eron') + '.'
      );
    } else if (rejectedType > 0) {
      showUploadError('Solo aceptamos imágenes (JPG, PNG, HEIC). ' + rejectedType + ' archivo(s) se omitieron.');
    } else {
      hideUploadError();
    }

    renderThumbs();
    refreshUploadState();
  }

  fileInput.addEventListener('change', e => {
    addFiles(e.target.files);
    fileInput.value = '';
  });

  ['dragenter', 'dragover'].forEach(ev => {
    zone.addEventListener(ev, e => {
      e.preventDefault();
      e.stopPropagation();
      zone.classList.add('is-drag');
    });
  });
  ['dragleave', 'drop'].forEach(ev => {
    zone.addEventListener(ev, e => {
      e.preventDefault();
      e.stopPropagation();
      zone.classList.remove('is-drag');
    });
  });
  zone.addEventListener('drop', e => {
    if (state.images.length >= MAX_FILES) {
      showUploadError('Llegaste al límite de ' + MAX_FILES + ' archivos. Quita uno antes de soltar otro.');
      return;
    }
    if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
  });

  /* Initial counter render */
  refreshUploadState();

  /* ---------- Summary ---------- */
  function updateSummary() {
    const sums = {
      categoria: state.categoria || '— sin definir —',
      medidas: (state.dim_l && state.dim_w && state.dim_h)
        ? state.dim_l + ' × ' + state.dim_w + ' × ' + state.dim_h + ' cm'
        : '— aprox —',
      material: state.material,
      acabado: state.acabado,
      plazo: state.plazo,
      imagenes: state.images.length === 0
        ? 'Sin adjuntar'
        : state.images.length + (state.images.length === 1 ? ' archivo' : ' archivos')
    };
    Object.keys(sums).forEach(k => {
      const el = document.querySelector('[data-sum="' + k + '"]');
      if (!el) return;
      el.textContent = sums[k];
      const isEmpty =
        (k === 'categoria' && !state.categoria) ||
        (k === 'medidas' && !(state.dim_l && state.dim_w && state.dim_h));
      el.classList.toggle('empty', isEmpty);
    });
  }

  /* ---------- WhatsApp message builder ---------- */
  function buildWaMessage(folio) {
    const dims = (state.dim_l && state.dim_w && state.dim_h)
      ? state.dim_l + '×' + state.dim_w + '×' + state.dim_h + ' cm'
      : 'aprox. por definir';

    const lines = [
      'Hola SpecWorks — quiero cotizar una pieza custom.',
      '',
      'Folio: ' + folio,
      'Nombre: ' + state.nombre,
      '',
      'Categoría: ' + state.categoria,
      'Medidas: ' + dims,
      'Material: ' + state.material,
      'Acabado: ' + state.acabado,
      'Plazo: ' + state.plazo,
      'Imágenes adjuntas: ' + state.images.length
    ];
    if (state.descripcion) {
      lines.push('', 'Detalle: ' + state.descripcion);
    }
    if (state.email) {
      lines.push('', 'Email: ' + state.email);
    }
    return lines.join('\n');
  }

  function buildWaUrl(folio) {
    const msg = encodeURIComponent(buildWaMessage(folio));
    return 'https://wa.me/' + waNumber + '?text=' + msg;
  }

  function generateLocalFolio() {
    // Solo se usa cuando el webhook no está configurado (modo placeholder).
    // El folio definitivo lo asigna Apps Script en producción.
    return 'TMP-' + String(Math.floor(Math.random() * 9000) + 1000);
  }

  /* ---------- File → base64 ---------- */
  function fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result || '';
        // result es "data:image/jpeg;base64,XXXX". Apps Script espera solo el base64.
        const idx = result.indexOf(',');
        resolve({
          name: file.name,
          type: file.type,
          size: file.size,
          base64: idx >= 0 ? result.substring(idx + 1) : result
        });
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });
  }

  /* ---------- Submit ---------- */
  const submitBtn = document.getElementById('submitBtn');
  const submitLabel = document.getElementById('submitLabel');
  const errorPanel = document.getElementById('cotError');
  const errorWa = document.getElementById('cotErrorWa');

  function showError() {
    if (!errorPanel) return;
    errorWa.setAttribute('href', buildWaUrl(state.folio || generateLocalFolio()));
    errorPanel.classList.add('is-visible');
  }
  function hideError() {
    if (errorPanel) errorPanel.classList.remove('is-visible');
  }
  function setLoading(isLoading) {
    submitBtn.classList.toggle('is-loading', isLoading);
    submitBtn.disabled = isLoading;
    submitLabel.textContent = isLoading ? 'Enviando…' : 'Enviar cotización';
  }

  function renderConfirmation(folio) {
    state.folio = folio;
    document.getElementById('folio').textContent = folio;
    goToStep(4);
  }

  async function submitToWebhook() {
    const filesPayload = await Promise.all(state.images.map(img => fileToBase64(img.file)));
    const payload = {
      categoria: state.categoria,
      marca: state.marca,
      modelo: state.modelo,
      anio: state.anio,
      descripcion: state.descripcion,
      dim_l: state.dim_l,
      dim_w: state.dim_w,
      dim_h: state.dim_h,
      material: state.material,
      acabado: state.acabado,
      plazo: state.plazo,
      nombre: state.nombre,
      whatsapp: state.whatsapp,
      email: state.email,
      consent: state.consent,
      files: filesPayload
    };

    // Apps Script Web Apps no soportan custom Content-Type sin preflight CORS.
    // Por eso mandamos como text/plain con JSON.stringify — Apps Script lo recibe
    // en e.postData.contents y JSON.parse() del lado server.
    const res = await fetch(webhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload)
    });

    if (!res.ok) throw new Error('HTTP ' + res.status);
    const data = await res.json();
    if (!data || !data.ok || !data.folio) throw new Error('Bad response');
    return data.folio;
  }

  submitBtn.addEventListener('click', async () => {
    if (!validateStep(3)) return;
    hideError();

    state.nombre = document.getElementById('nombre').value.trim();
    state.whatsapp = document.getElementById('whatsapp').value.trim();
    state.email = document.getElementById('email').value.trim();

    /* Modo sin webhook configurado: fallback directo a wa.me con folio local */
    if (!webhookUrl) {
      const folio = generateLocalFolio();
      renderConfirmation(folio);
      setTimeout(() => { window.open(buildWaUrl(folio), '_blank', 'noopener'); }, 700);
      return;
    }

    /* Modo con webhook: POST a Apps Script */
    setLoading(true);
    try {
      const folio = await submitToWebhook();
      renderConfirmation(folio);
    } catch (err) {
      console.error('[cotizador] submit failed:', err);
      showError();
    } finally {
      setLoading(false);
    }
  });
})();
